module.exports = __webpack_public_path__ + "img/RandoBoy.b08fc364.png";